<template>
<ais-instant-search index-name="items" :search-client="searchClient" > 
  <v-app id="inspire">
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="white"
      dark
    >
<!--      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />-->

      <v-toolbar-title
        style="width: 350px"
      >
        <a href="/" class="deep-orange--text" style="text-decoration: none"><v-icon>mdi-truck</v-icon>&nbsp; Sendsoko</a>
      </v-toolbar-title>
     <!-- start search -->  


<ais-search-box placeholder="Search here" class="col-md-6"></ais-search-box>

    


<!-- end search --> 
      <v-spacer />
      <v-btn icon>
        <v-icon>mdi-account-circle</v-icon>
      </v-btn>
      <v-btn v-on="on" icon>
        <v-badge
          content="2"
          value="2"
          color="green"
          overlap
        >
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
      <v-btn v-on="on" href="/cart" icon>
        <v-badge
          content="2"
          value="2"
          color="green"
          overlap
        >
          <v-icon>mdi-cart</v-icon>
        </v-badge>
      </v-btn>
    </v-app-bar>
    <v-content>
   <ais-state-results >
      <template slot-scope="{ state: { query } }">
         

        <ais-hits ref="searchHits" v-show="query.length > 0">
    
            <router-link slot="item" slot-scope="{ item }" :to="{
                            name: 'Product',
                            params: { productId: item.objectID }
                          }"  @click.native="resetSearch();refreshSelf(item.objectID)">

              <div class="row">
                <div class="col-md-4">
             <v-img
                    class="white--text align-end"
                    :aspect-ratio="16 / 9"
                    height="50px"
                    :src="item.imageUrl"
                  ></v-img>
                </div>

                <div class="col-md-8">
                <h2>{{ item.itemName}}</h2>
                <p>KES. {{ item.itemPrice}}</p>
                </div>
            </div>
            </router-link>
                                
        </ais-hits>
      </template>
    </ais-state-results> 
    </v-content>
    
      <router-view/>
    <v-footer
      :padless="true"
    >
      <v-card
        flat
        tile
        width="100%"
        class="secondary white--text nametext-center"
      >
        <v-card-text>
          <v-btn
            class="mx-4 white--text"
            icon
          >
            <v-icon size="24px">mdi-home</v-icon>
          </v-btn>
          <v-btn
            class="mx-4 white--text"
            icon
          >
            <v-icon size="24px">mdi-email</v-icon>
          </v-btn>
          <v-btn
            class="mx-4 white--text"
            icon
          >
            <v-icon size="24px">mdi-calendar</v-icon>
          </v-btn>
           <v-btn
            class="mx-4 white--text"
            icon
          >
            <v-icon size="24px">mdi-delete</v-icon>
          </v-btn>

        </v-card-text>

       

        <v-divider></v-divider>

        <v-card-text class="white--text">
          {{ new Date().getFullYear() }} — <strong>sendsoko</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
  </ais-instant-search> 
</template>
<script> 

 import algoliasearch from  'algoliasearch/lite';
import 'instantsearch.css/themes/satellite-min.css';
import { mapState, mapActions } from "vuex"; 


    export default {
        data () {
            return {
                searchClient: algoliasearch(
        '3AV9AUVNSM',
        'f82adba3bcff8507a51e40c9d21e1f6a'
      ),
             
                
       
            }
        },
         methods: {
           refreshSelf(key) {
    
      this.$store.commit("setId", key);
      this.$store.commit("setCurr", this.$store.getters.productList[key]);
      console.log("data from shop" + this.$store.getters.productList[key]);
      console.log("current key is:" + this.$store.state.currId);
      console.log("current curr is:" + this.$store.state.curr);
      window.scrollTo(0, 0);
    },

     resetSearch() { 

      //this method is not being users due to errors
        document
        .querySelectorAll('.ais-SearchBox-input')
        .forEach((e) => (e.value = ''))

      // clear all the hits
      document.querySelectorAll('.ais-Hits-item').forEach((e) => e.remove())

      // also clear the hits from the component, otherwise subsequent searches throw exceptions
    this.$refs.searchHits.state.hits = []
  
     this.componentKey += 1;
     
  },
  }
    }
</script>



// WEBPACK FOOTER //
// src/components/Layout.vue